import React from "react";
import { RouteObject } from "react-router-dom";
import DataUploadPage from "./components/data-upload-landing/landing";
import FileUploadPage from "./components/file-upload/FileUpload";
import DataMappingPage from "./components/data-mapping/DataMapping";
import DataValidation from "./components/data-validations/DataValidation";
import MigrationExecution from "./components/data-result/DataMigrationResult";
import PlanAreaMapping from "./components/plan-area-mapping/PlanAreaMapping";
import DataFieldUpdation from "./components/data-field-updation/DataFieldUpdation";
import DataMigrationLanding from "./components/data-upload-landing/Cards";
import CategorizedDataTypeSelection from "./components/data-type-selection/CategorizedDataTypeSelection";
import UploadMethodSelection from "./components/upload-method/UploadMethodSelection";
import DataRelationMapping from "./components/data-relationship-mapping/DataRelationshipMapping";
import { TemplateDetailView } from "./components/data-saved/details/TemplateDetailView";

export interface DataMigrationRoutes extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: DataMigrationRoutes[];
}

export const dataMigrationRoutes: DataMigrationRoutes[] = [
  {
    path: "/onboarding/data-migration/data-cards",
    element: <DataMigrationLanding />,
  },
  {
    path: "/onboarding/data-migration/data-setup",
    element: <DataUploadPage />,
  },
  {
    path: "/onboarding/data-migration/data-selection",
    element: <CategorizedDataTypeSelection />,
  },
  {
    path: "/onboarding/data-migration/upload-method",
    element: <UploadMethodSelection />,
  },
  {
    path: "/onboarding/data-migration/file-upload",
    element: <FileUploadPage />,
  },
  {
    path: "/onboarding/data-migration/data-mapping",
    element: <DataMappingPage />,
  },
  {
    path: "/onboarding/data-migration/data-validation/:sessionId",
    element: <DataValidation />,
  },
  {
    path: "/onboarding/data-migration/data-relationship-mapping/:selectedType/:uploadId",
    element: <DataRelationMapping />,
  },
  {
    path: "/onboarding/data-migration/migration-execution/:sessionId",
    element: <MigrationExecution />,
  },
  {
    path: "/onboarding/data-migration/plan-area-mapping",
    element: <PlanAreaMapping />,
  },
  {
    path: "/onboarding/data-migration/data-field-updation",
    element: <DataFieldUpdation />,
  },
  {
    path: "onboarding/data-migration/saved-templates/details/:id",
    element: <TemplateDetailView />,
  },
];
